<div class="row">
  <div #cardview class="col-12 float-left">
    <mat-card appearance="outlined" class="card-widget nopadLR marB16 nopadB" [style.height]="height">
      <mat-card-header class="marLR24 marT8 chat-header">
        <mat-card-title class="flex">
          <div class="flex80">
            <h2 name="chat" class="h3Header GreyDarkest marB4 d-block">
              Chat
              <span class="h5Header marL16 GreyLight">To Do</span>
            </h2>
          </div>
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <ul class="listItemSingle scroll-viewport" #scroller [style.height]="ulheight">
          <li *ngFor="let item of messageArray">
            <span class="clearfix nopadB" *ngIf="item.user?.empName !== user?.empName">
              <span class="listLeft">
                <span class="data-letters color-left float-left marLR8">{{ item.user?.empName | initials }}</span>
                <span class="marginicon40">
                  <p class="mainBodyTxt3 GreyLight">{{ item.user?.empName }}</p>
                </span>
              </span>
              <span class="vertical-RightCenter float-right marR24">
                <p class="mainBodyTxt4 GreyLight">{{ item.timesent | date: 'MMM d, y, h:mm a' }}</p>
              </span>
            </span>
            <span class="clearfix nopadB" *ngIf="item.user?.empName === user?.empName">
              <span class="listLeft vertical-LeftCenter">
                <p class="mainBodyTxt4 GreyLight">{{ item.timesent | date: 'MMM d, y, h:mm a' }}</p>
              </span>
              <span class="vertical-RightCenter float-right marR24">
                <span class="data-letters color-right float-right marL8">{{ item.user.empName | initials }}</span>
                <span class="float-right">
                  <p class="mainBodyTxt3 GreyLight">{{ item.user.empName }}</p>
                </span>
              </span>
            </span>
            <span class="clearfix nopadT">
              <p class="mainBodyTxt4 GreyDarkest message">{{ item.message }}</p>
            </span>
          </li>
        </ul>
        <span class="listItemSingle messagebox">
          <ul>
            <li class="active clearfix">
              <span class="messagebox-container">
                <span class="message-data-letters">{{ user?.empName | initials }}</span>
                <div class="messagebox-formfield relative">
                  <input
                    name="messages"
                    matTooltip="Only alphanumeric characters and space are allowed"
                    [matTooltipPosition]="'below'"
                    [(ngModel)]="message"
                    (keydown)="handleSubmit($event)"
                    placeholder="Write messages down here..."
                    class="messagebox-input"
                    autocomplete="off"
                  />
                  <a
                    href="javascript:void(0)"
                    (click)="sendMessage()"
                    class="messagebox-icon iconinline icon x-24 send-icon"
                  ></a>
                </div>
              </span>
            </li>
          </ul>
        </span>
      </mat-card-content>
    </mat-card>
  </div>
</div>
